import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';
import logger from '../../utils/logger';

class PaymentAlertsService {
  fetchAlerts = async (
    page = 1,
    pageSize = 10,
    alertType = '',
    tripId = '',
    shipmentId = '',
    tripShipmentId = '',
    fromDate = '',
    toDate = '',
  ) => {
    try {
      const clampedPage = Math.max(1, Number(page) || 1);
      const clampedPageSize = Math.min(
        100,
        Math.max(1, Number(pageSize) || 10),
      );
      let url = `${BASE_URL}/v1/alerts/paymentalerts?page=${clampedPage}&pageSize=${clampedPageSize}`;

      if (alertType) {
        url += `&alert_type=${encodeURIComponent(alertType)}`;
      }
      if (tripId) {
        url += `&tripId=${encodeURIComponent(String(tripId).trim())}`;
      }
      const shipmentIdVal = String(shipmentId).trim();
      if (shipmentIdVal) {
        url += `&shipmentId=${encodeURIComponent(shipmentIdVal)}`;
      }
      if (tripShipmentId) {
        url += `&tripShipmentId=${encodeURIComponent(
          String(tripShipmentId).trim(),
        )}`;
      }
      if (fromDate) {
        url += `&from_date=${encodeURIComponent(fromDate)}`;
      }
      if (toDate) {
        url += `&to_date=${encodeURIComponent(toDate)}`;
      }

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      logger.error('Error fetching payment alerts:', error);
      throw error;
    }
  };
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new PaymentAlertsService();
